import React from "react";
import PreviewAvatar from "./PreviewAvatar";

const UnipAvatarEditor = ({userAvatar, setNewUserAvatar, displayName, avatarColor, editMode, setEditMode, ...props}) => {
    const [state, setState] = React.useState({
        userImage: userAvatar,
        image: userAvatar ?? null,
        position: {x: 0, y: 0},
        scale: 1,
        rotate: 0,
        borderRadius: 35,
        border: 1,
        preview: undefined,
        image64: null,
        width: 200,
        height: 200,
        backgroundColor: 'transparent',
        color: [255, 255, 255, 0.6],
    });

    React.useEffect(()=>{
        setState(prevState => ({
            ...prevState,
            userImage: userAvatar,
            image64: userAvatar ?? null
        }))
    }, [userAvatar])



    const handleClickEdit = () => {
        setEditMode(true);
    }
    const reverseDisplayName = (name) => {
        return name.split(' ').reverse().join(' ');
    };
    console.log(state.userImage);
            return <PreviewAvatar
                image={state.userImage}
                handleEdit={handleClickEdit}
                name={reverseDisplayName(displayName)}
                color="#EF595D"
                maxInitials={4}
                textSizeRatio={2}
                round={"50%"}
                size={120}
                avatarClass="avatar-border"
            />
}
export default UnipAvatarEditor
